import { ModuleContent } from '../contract';

/**
 * Content for the IFrame module.
 * Mirrors the settings available in the legacy AngularJS container module.
 */
export type IFrameModuleContent = {
	iframeSrc: string;
	useQueryString: boolean;
	queryStringName?: string;
};

export function isIFrameModuleContent(content: ModuleContent): content is IFrameModuleContent {
	return typeof (content as IFrameModuleContent).iframeSrc === 'string';
}
